// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__wePC4","profilenavigation":"Profile_profilenavigation__j2Lif"};